import React, { useState, useEffect, useCallback, useRef } from 'react'
import { GoogleMap, useJsApiLoader, Marker, Circle, InfoWindow } from '@react-google-maps/api'
import './FacilityMap.css'
 
const containerStyle = {
  width: '100%',
  height: '70vh',
}
 
const center = {
  lat: 27.964157,
  lng: -82.4572,
}
 
const FacilityMap = ({ facilities = [], selectedProviderFacilities = [], providerList = [], Radius, types, MarkerClick = () => {}, onFilter = () => {}, setFacilities, isDropdownVisible, scheduleAppointmentPatinet, controlledByParent = false, selectedDiagnosisName = '', selectedStatus = null, selectedFacilityType = null }) => {
  const { isLoaded } = useJsApiLoader({ id: 'google-map-script', googleMapsApiKey: 'AIzaSyBQWNt0CI8rCrIdFt6_AUgExvRONdbm_ZI' })
  const [selectedProvider, setSelectedProvider] = useState('')
  const [selectedProviderFacitily, setSelectedProviderFacitily] = useState([])
  const [hoveredFacility, setHoveredFacility] = useState(null)
  const [statusChange, setStatusChange] = useState(null)
  const [map, setMap] = useState(null)
  const [zoom, setZoom] = useState(1)
  const [selectedFacilityTypeFilter, setSelectedFacilityTypeFilter] = useState(null)
  const hoverCloseTimeoutRef = useRef(null)

  const clearHoverCloseTimer = useCallback(() => {
    if (hoverCloseTimeoutRef.current) {
      clearTimeout(hoverCloseTimeoutRef.current)
      hoverCloseTimeoutRef.current = null
    }
  }, [])

  const showFacilityInfo = useCallback((facility) => {
    clearHoverCloseTimer()
    setHoveredFacility((currentFacility) => {
      const currentKey = controlledByParent ? currentFacility?.ID : currentFacility?.Name
      const nextKey = controlledByParent ? facility?.ID : facility?.Name
      return currentKey === nextKey ? currentFacility : facility
    })
  }, [clearHoverCloseTimer, controlledByParent])

  const scheduleHideFacilityInfo = useCallback(() => {
    clearHoverCloseTimer()
    hoverCloseTimeoutRef.current = setTimeout(() => {
      setHoveredFacility(null)
      hoverCloseTimeoutRef.current = null
    }, 700)
  }, [clearHoverCloseTimer])
  const onLoad = useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center)
    // map.fitBounds(bounds);
    map.setZoom(10)
    setMap(map)
  }, [])
 
  const onUnmount = useCallback(function callback(map) {
    clearHoverCloseTimer()
    setMap(null)
  }, [clearHoverCloseTimer])

  useEffect(() => {
    return () => {
      clearHoverCloseTimer()
    }
  }, [clearHoverCloseTimer])
 
  // const StatusMap = {
  //   "In Progress": "yellow",
  //   "Completed": "red",
  //   "Pending": "green",
  //   "Sister": ""
  // };
  const StatusMap = controlledByParent
    ? {
        '<10': 'red',
        '10-20': 'yellow',
        '>20': 'green',
      }
    : {
        'Not In': 'red',
        'Credentialing (In Progress)': 'yellow',
        Credentialed: 'green',
      }
 
  const testMarker = (facility, isPresent) => {
    let strokeColor
    if (controlledByParent) {
      const count = Number(facility.patientCount || 0)
      if (count < 10) {
        strokeColor = 'red'
      } else if (count >= 10 && count <= 20) {
        strokeColor = 'yellow'
      } else {
        strokeColor = 'green'
      }
    } else {
      let credentialed = selectedProviderFacilities.filter((item) => parseInt(item.FacilityID) == facility.ID)[0]
      if (providerList.length > 0) {
        if (!isPresent) {
          strokeColor = 'red'
        } else if (credentialed?.Credentialed === 'Yes') {
          strokeColor = 'green'
        } else if (credentialed?.Credentialed === 'In Progress') {
          strokeColor = 'yellow'
        } else {
          strokeColor = 'red' // "No"
        }
      } else {
        strokeColor = 'green'
      }
    }
 
    return `data:image/svg+xml;charset=UTF-8;base64,${btoa(
      `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="${strokeColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="square">
        <rect x="2" y="2" width="28" height="28" rx="6" ry="6" />
        <text x="16" y="21" text-anchor="middle" font-size="16" font-weight="200" fill="#000000">${facility.Marker}</text>
      </svg>`,
    )}`
  }
 
  // const StatusColour = () => {
  //   return (
  //     <div className="map-legend">
  //       <ul
  //         style={{
  //           display: 'flex',
  //           flexWrap: 'wrap',
  //           marginTop: '10px',
  //           gap: '5px 10px',
  //           padding: 'unset',
  //         }}
  //       >
  //         <h6 style={{ fontWeight: '600' }}>Status Legend :</h6>
  //         {Object.keys(StatusMap).map((status) => (
  //           <li
  //             key={status}
  //             style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}
  //             onClick={() => {
  //               onFilter('status', status, '', '', true) // send actual status
 
  //             }}
  //           >
  //             <b>
  //               <MarkerImage color={StatusMap[status]} legend={true} />
  //             </b>
  //             <b>{status}</b>
  //           </li>
  //         ))}
  //       </ul>
  //     </div>
  //   )
  // }
  const StatusColour = () => (
    <div className={controlledByParent ? "status-legend-floating" : "legend-section status-legend"}>
      <div className="legend-title">Status Legend</div>
      <div className="legend-items">
        {Object.keys(StatusMap).map((status) => {
          const isSelected = selectedStatus === status
 
          return (
            <button
              key={status}
              type="button"
              className={`legend-item ${isSelected ? 'selected' : ''}`}
              onClick={() => {
                if (isSelected) {
                  onFilter('status', 'all')
                } else {
                  onFilter('status', status, '', '', true)
                }
              }}
            >
              <span className="legend-color" style={{ backgroundColor: StatusMap[status], borderColor: StatusMap[status] }} />
              <span className="legend-text">{controlledByParent ? `${status} Patients` : status}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
  const MapLegend = () => (
    <div className="legend-section map-legend">
      <div className="legend-title">Map Legend</div>
      <div className="legend-items">
        {types?.map((obj) => {
          const selectedType = controlledByParent ? selectedFacilityType : selectedFacilityTypeFilter
          const isSelected = selectedType === obj.Name
 
          return (
            <button
              key={obj.Name}
              type="button"
              className={`legend-item ${isSelected ? 'selected' : ''}`}
              onClick={() => {
                if (isSelected) {
                  setSelectedFacilityTypeFilter(null)
                  onFilter('type', 'all')
                } else {
                  setSelectedFacilityTypeFilter(obj.Name)

                  if (controlledByParent) {
                    onFilter('type', obj.Name)
                  } else if (providerList.length > 0) {
                    onFilter('type', 'radius', providerList[0].ID, obj.Name)
                  } else {
                    onFilter('type', obj.Name)
                  }
                }
              }}
            >
              <div className={`map-box ${isSelected ? 'selected' : ''}`}>{obj.Marker}</div>
              <span className="legend-text">{obj.Name}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
 
  const renderFacilities = (props) => {
    return facilities.map((facility, index) => {
      const facilityLat = parseFloat(facility.Lat)
      const facilityLng = parseFloat(facility.Lng)
      if (!Number.isFinite(facilityLat) || !Number.isFinite(facilityLng)) return null

      const isFacilityInSelectedProvider = selectedProviderFacilities.some((selectedFacility) => parseInt(selectedFacility.FacilityID) == facility.ID)
      return (
        <React.Fragment key={index}>
          <Marker
            position={{ lat: facilityLat, lng: facilityLng }}
            icon={{
              url: testMarker(facility, isFacilityInSelectedProvider),
              scaledSize: new window.google.maps.Size(24, 24),
            }}
            onMouseOver={() => showFacilityInfo(facility)}
            onMouseOut={scheduleHideFacilityInfo}
            onClick={() => MarkerClick(facility)}
          />
        </React.Fragment>
      )
    })
  }

  const renderHoveredFacilityInfo = () => {
    if (!hoveredFacility) return null

    const facilityLat = parseFloat(hoveredFacility.Lat)
    const facilityLng = parseFloat(hoveredFacility.Lng)
    if (!Number.isFinite(facilityLat) || !Number.isFinite(facilityLng)) return null

    return (
      <InfoWindow
        position={{ lat: facilityLat, lng: facilityLng }}
        options={controlledByParent ? { disableAutoPan: true } : { pixelOffset: new window.google.maps.Size(0, -10) }}
      >
        {controlledByParent ? (
          <div
            className="facility-map-theme__info-window"
            onMouseEnter={clearHoverCloseTimer}
            onMouseLeave={scheduleHideFacilityInfo}
            style={{ maxHeight: '215px', overflowY: 'auto', minWidth: '150px', overscrollBehavior: 'contain' }}
          >
            <h6 style={{ margin: '0 0 5px 0', fontSize: '13px', fontWeight: 'bold', color: 'inherit' }}>{hoveredFacility.Name}</h6>
            {selectedDiagnosisName && selectedDiagnosisName !== 'Any diagnosis' && (
              <div style={{ fontSize: '12px', marginBottom: '5px', fontWeight: 'bold' }}>
                {selectedDiagnosisName} - {hoveredFacility.patientCount || 0}
              </div>
            )}
            {hoveredFacility.filteredPatients && hoveredFacility.filteredPatients.length > 0 ? (
              <ul style={{ margin: 0, paddingLeft: '15px', fontSize: '11px', listStyleType: 'disc' }}>
                {hoveredFacility.filteredPatients.map((p, idx) => (
                  <li key={idx}>{p.PatientName || `${p.FirstName || ''} ${p.LastName || ''}`.trim() || 'Unknown Patient'}</li>
                ))}
              </ul>
            ) : (
              <div style={{ fontSize: '11px', fontStyle: 'italic', opacity: 0.8 }}>No patients match criteria</div>
            )}
          </div>
        ) : (
          <div>
            <b>Name:</b> {hoveredFacility.Name}
            <p>
              <b>Address:</b> {hoveredFacility.Address}
            </p>
            <p>
              <b>Type:</b> {hoveredFacility.Type}
            </p>
          </div>
        )}
      </InfoWindow>
    )
  }
 
  useEffect(() => {
    if (controlledByParent) return
    providerList.map((provider, index) => {
      onFilter('type', 'radius', provider.ID)
    })
  }, [Radius, controlledByParent])
 
  useEffect(() => {
    if (controlledByParent) return
    if (providerList.length > 0) {
      onFilter('type', 'radius', providerList[0].ID)
    } else {
      onFilter('type', 'all')
    }
    setSelectedFacilityTypeFilter(null)
  }, [providerList, controlledByParent])
 
  useEffect(() => {
    if (controlledByParent) return
    if (providerList.length > 0) {
      onFilter('type', 'radius', providerList[0].ID)
    }
    setSelectedFacilityTypeFilter(null)
  }, [selectedProviderFacilities, controlledByParent])
 
  useEffect(() => {
    if (controlledByParent) return
    onFilter('type', 'status', statusChange)
  }, [statusChange, controlledByParent])
 
  useEffect(() => {
    if (controlledByParent) return
    if (isDropdownVisible) {
      renderFacilities()
      if (providerList.length > 0) {
        onFilter('type', 'radius', providerList[0].ID)
      }
    }
  }, [isDropdownVisible, controlledByParent])
 
  const renderProviders = (props) => {
    if (!providerList || providerList.length === 0) return null
    return providerList.map((provider, index) => {
      const providerLat = parseFloat(provider.Lat)
      const providerLng = parseFloat(provider.Lng)
      if (!Number.isFinite(providerLat) || !Number.isFinite(providerLng)) return null

      return (
        <React.Fragment key={index}>
          <Circle onClick={() => onFilter('type', 'radius', provider.ID)} radius={Math.round(Radius * 1609.34)} center={{ lat: providerLat, lng: providerLng }} />
          <Marker
            position={{ lat: providerLat, lng: providerLng }}
            icon={{
              url: `data:image/svg+xml;charset=UTF-8;base64,${btoa(
                `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="red}" stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM12 11.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>`,
              )}`,
            }}
            onMouseOver={() => setHoveredFacility(provider)}
            onMouseOut={() => setHoveredFacility(null)}
            onClick={() => MarkerClick(provider.Name)}
          />
          {hoveredFacility && hoveredFacility.Name === provider.Name && (
            <InfoWindow position={{ lat: parseFloat(provider.Lat), lng: parseFloat(provider.Lng) }}>
              <div>
                <b>Name:</b> {provider.Name}
                <p>
                  <b>Address:</b> {provider.Address}
                </p>
              </div>
            </InfoWindow>
          )}
          ;
        </React.Fragment>
      )
    })
  }
 
  return isLoaded ? (
    <>
      <div className="facility-map-theme__map-shell" style={{ position: 'relative' }}>
        {controlledByParent && <StatusColour />}
        <GoogleMap mapContainerStyle={containerStyle} center={center} onLoad={onLoad} onUnmount={onUnmount}>
          {renderFacilities()}
          {renderHoveredFacilityInfo()}
          {renderProviders()}
        </GoogleMap>
        <div className="legend-wrapper">
          {!controlledByParent && <StatusColour />}
          <MapLegend />
        </div>
      </div>
    </>
  ) : (
    <></>
  )
}
 
export default FacilityMap
